import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UserManagement from './UserManagement';
import GroupManagement from './GroupManagement';
import PermissionManagement from './PermissionManagement';
import Profile from './Profile';
import NotificationSettings from './NotificationSettings';

const SettingsRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/settings/profile" replace />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/users" element={<UserManagement />} />
      <Route path="/groups" element={<GroupManagement />} />
      <Route path="/permissions/:groupId" element={<PermissionManagement />} />
      <Route path="/notifications" element={<NotificationSettings />} />
      <Route path="*" element={<Navigate to="/settings/profile" replace />} />
    </Routes>
  );
};

export default SettingsRouter;